import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { Form, LevelsAutocomplete } from "@shared/components";

export function DefaultPlanForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="name"
          label={translate("default_plan_admin.fields.name")}
          required
        />
      </Grid>
     <Grid size={{ xs: 12 }}>
        <Form.Input
          name="description"
          label={'Descrição'}
          multiline
          minRows={4}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="access_amount"
          label={translate("default_plan_admin.fields.access_amount")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="value"
          label={translate("default_plan_admin.fields.value")}
          type="text"
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="vindi_page"
          label={translate("default_plan_admin.fields.vindi_page")}
          placeholder={translate("default_plan_admin.placeholders.vindi_page")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="vindi_token"
          label={translate("default_plan_admin.fields.vindi_token")}
          placeholder={translate("default_plan_admin.placeholders.vindi_token")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="audiobook_quantity"
          label={translate("default_plan_admin.fields.audiobook_quantity")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="book_quantity"
          label={translate("default_plan_admin.fields.book_quantity")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="magazine_quantity"
          label={translate("default_plan_admin.fields.magazine_quantity")}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="plan_types"
          multiple
          label={'Tipo de Plano'}
          options={[
            { value: "club", label: "Clube" },
            { value: "book", label: "Livros" },
            { value: "magazine", label: "Revistas" },
          ]}
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <LevelsAutocomplete
          name="level"
          label={translate("default_plan_admin.fields.level")}
        />
      </Grid>
    </Grid>
  );
}
